@if (!isWebAppLink) {
  <div class="lm-card-view" [ngClass]="cardViewClasses">
    @if (hasImage || fromHomeSuite) {
      <div class="lm-card-image" [ngClass]="cardImageClasses">
        @if (hasImage) {
          <img class="avatar" [ngClass]="{'large': isLargeScale, 'smallImg': !isLargeScale, 'noFloat' : isParagraph }" src="{{imageUrl}}" alt="" (click)="onClickEvent($event)"/>
        }
        <!-- decorative image, alt can be left blank since there's a title span below -->
      </div>
    }
    <div class="lm-card-content" [ngClass]="{'titlePadding': isParagraph }">
      <div class="lm-card-title" [ngClass]="{'adjustTitle': !isLargeScale }" >
        <a soho-hyperlink
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          [style.width]="showBarCode ? '80%' : 'fit-content'"
          soho-tooltip title="{{mouseOverText | formatMessageRule:true:mouseOverText:model:specFields}}" [placement]="'offset'" [offset]="-30"
          (fieldEvent)="onFieldEvent($event)"
          (keydown.enter)="onClickEvent($event)"
          (click)="onClickEvent($event)">
          <span [ngClass]="{'paraTitle': isParagraph }">{{title | formatMessageRule:true:title:model:specFields}}</span>
        </a>
        @if (showBarCode) {
          <button
            soho-button="icon"
            icon="barcode"
            id="barcode-id"
            (click)="onBarCodeClick()">
          </button>
        }
      </div>
      @if (!!description.resourceValue || fromHomeSuite) {
        @if (!isParagraph) {
          <div class="lm-card-flex">
            <div class="lm-column">
              @if (isLargeScale) {
                <p soho-tooltip #cardDescription
                  class="lm-card-description"
                  (mouseenter)="showToolTip(cardDescription)"
                  title="{{isMultiLineDescription ? (description | formatMessageRule:true:description:model:specFields) : ''}}"
                >{{description | formatMessageRule:true:description:model:specFields}}</p>
              }
            </div>
          </div>
        }
      }
    </div>
  </div>
}

@if (isWebAppLink) {
  <div class="lm-card-view" (click)="onClickEvent($event)" [style.cursor]="'pointer'" [ngClass]="cardViewClasses">
    @if (hasImage || fromHomeSuite) {
      <div class="lm-card-image" [ngClass]="cardImageClasses">
        <!-- Added an empty alt="" to indicate the image is decorative/does not convey meaningful information. -->
        @if (hasImage) {
          <img class="avatar large" alt="" src="{{imageUrl}}"/>
        }
      </div>
    }
    <div class="lm-card-content">
      <div class="lm-card-title">
        <a soho-hyperlink
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          soho-tooltip title="{{mouseOverText | formatMessageRule:true:mouseOverText:model:specFields}}" [placement]="'offset'" [offset]="-30"
          (keydown.enter)="onClickEvent($event)"
          (fieldEvent)="onFieldEvent($event)">
          <span>{{title | formatMessageRule:true:title:model:specFields}}</span>
        </a>
      </div>
      @if (!!description || fromHomeSuite) {
        <div class="lm-card-flex">
          <div class="lm-column">
            <p soho-tooltip #cardDescription
              (mouseenter)="showToolTip(cardDescription)"
              title="{{isMultiLineDescription ? (description | formatMessageRule:true:description:model:specFields) : ''}}">
            {{description | formatMessageRule:true:description:model:specFields}}</p>
          </div>
        </div>
      }
      @if (isWebAppLink) {
        <button
          soho-menu-button
          hideMenuArrow="true"
          class="btn-actions"
          icon="star-outlined"
          title="{{'SetPreferred' | translate}}"
          [attachToBody]="true"
          [removeOnDestroy]="true"
          [autoFocus]="true"
          (click)="onPreferredMenuEvent($event)"
          [style.visibility]="inMingleWidget || !allowedToSetPreferred ? 'hidden' : 'visible'"
          >
          <span class="audible">{{'More' | translate}} - {{title | formatMessageRule:true:title:model:specFields}}</span>
        </button>
      }
    </div>
  </div>
}
